import React from 'react'

export const Tablet = ({ viewdata, cmtznLoader }) => {
  return (
    <div>Tablet</div>
  )
}
